import SectionHeader from "../../individual/SectionHeader/SectionHeader";
import "./Patrocinadors.css";
import logo1 from "../../../assets/logoCellnex.png";
import logo2 from "../../../assets/CIB.png";
import logo3 from "../../../assets/auren-logo.png";
import logo4 from "../../../assets/logo-bonArea.svg";
import sabadellLogo from "../../../assets/logoSabadell.png";
import fundacioLaCaixa from "../../../assets/logo-fundacio-lacaixa (1).webp";
import naturgyLogo from "../../../assets/Naturgy_logo.png";
import sercotelLogo from "../../../assets/logo-Sercotel.png";
import aiguesBarcelona from "../../../assets/aigues-de-barcelona (1).jpg";
import caixabank from "../../../assets/caixabank-logo.png";
import saba from "../../../assets/logo-saba.jpg";
import generalitat from "../../../assets/logo-generalitat.png";
import fundacio from "../../../assets/fundacio-transparent.png";
import bove from "../../../assets/Bové Montero horizontal.png";
import crowe from "../../../assets/crowe.png";
import faura from "../../../assets/faura_casas_transparent.png";
import forward from "../../../assets/Fowardecomics .png";
import eurogrup from "../../../assets/Euro_Group-blue.png";
import eade from "../../../assets/EADe-Logo (1).png";
const Patrocinadors = () => {
  return (
    <div className="patrocinadors__container" id="patrocinadors">
      <SectionHeader title={"Patrocinadors Exclusius"} bottomMargin={true} />
      <div className="patrocinadors__item-wrapper">
        <a
          href="https://www.bancsabadell.com/bsnacional/es/particulares/"
          target="_blank"
          rel="noreferrer"
        >
          <img
            alt="patrocini"
            src={sabadellLogo}
            className="patrocinadors__item"
          />
        </a>
        <a href="https://www.cellnex.com/es/" target="_blank" rel="noreferrer">
          <img alt="patrocini" src={logo1} className="patrocinadors__item" />
        </a>
        <a
          href="https://fundacionlacaixa.org/ca/"
          target="_blank"
          rel="noreferrer"
        >
          <img
            alt="patrocini"
            src={fundacioLaCaixa}
            className="patrocinadors__item"
            style={{ maxWidth: "250px" }}
          />
        </a>
        <a href="https://www.naturgy.es/hogar" target="_blank" rel="noreferrer">
          <img
            alt="patrocini"
            src={naturgyLogo}
            className="patrocinadors__item"
          />
        </a>
        <a
          href="https://www.sercotelhoteles.com/es"
          target="_blank"
          rel="noreferrer"
        >
          <img
            alt="patrocini"
            src={sercotelLogo}
            className="patrocinadors__item"
            style={{ maxWidth: "170px" }}
          />
        </a>
      </div>
      <SectionHeader
        title={"Patrocinadors Premium"}
        bottomMargin={true}
        marginTop={true}
      />
      <div className="patrocinadors__item-wrapper">
        <a
          href="https://www.aiguesdebarcelona.cat/es/"
          target="_blank"
          rel="noreferrer"
        >
          <img
            alt="patrocini"
            src={aiguesBarcelona}
            className="patrocinadors__item"
          />
        </a>
        <a
          href="https://www.caixabank.es/particular/home/particulares_es.html"
          target="_blank"
          rel="noreferrer"
        >
          <img
            alt="patrocini"
            src={caixabank}
            className="patrocinadors__item"
          />
        </a>

        <a href="https://www.saba.es/es/" target="_blank" rel="noreferrer">
          <img
            alt="patrocini"
            src={saba}
            className="patrocinadors__item"
            style={{ maxWidth: "170px" }}
          />
        </a>
      </div>
      <SectionHeader
        title={"Patrocinadors Bàsics"}
        bottomMargin={true}
        marginTop={true}
      />
      <div className="patrocinadors__item-wrapper">
        <a href="https://auren.com/es/" target="_blank" rel="noreferrer">
          <img alt="patrocini" src={logo3} className="patrocinadors__item" />
        </a>
        <a href="https://www.bonarea.com/ca" target="_blank" rel="noreferrer">
          <img alt="patrocini" src={logo4} className="patrocinadors__item" />
        </a>
        <a
          href="https://cib.partners/ca/inici/"
          target="_blank"
          rel="noreferrer"
        >
          <img alt="patrocini" src={logo2} className="patrocinadors__item" />
        </a>
      </div>
      <SectionHeader
        title={"Entitats col·laboradores"}
        bottomMargin={true}
        marginTop={true}
      />
      <div className="patrocinadors__item-wrapper">
        <a href="https://bovemontero.com/" target="_blank" rel="noreferrer">
          <img alt="colaborador" src={bove} className="patrocinadors__item" />
        </a>
        <a
          href="https://www.crowe.com/es/services/auditoria"
          target="_blank"
          rel="noreferrer"
        >
          <img alt="colaborador" src={crowe} className="patrocinadors__item" />
        </a>
        <a href="https://ead-consultors.com/" target="_blank" rel="noreferrer">
          <img alt="colaborador" src={eade} className="patrocinadors__item" />
        </a>
        <a href="https://euro-grup.com/es/" target="_blank" rel="noreferrer">
          <img
            alt="colaborador"
            src={eurogrup}
            className="patrocinadors__item"
          />
        </a>
        <a
          href="https://www.faura-casas.com/es/"
          target="_blank"
          rel="noreferrer"
        >
          <img alt="colaborador" src={faura} className="patrocinadors__item" />
        </a>
        <a
          href="http://www.forwardeconomics.com/"
          target="_blank"
          rel="noreferrer"
        >
          <img
            alt="colaborador"
            src={forward}
            className="patrocinadors__item"
          />
        </a>
        <a
          href="https://www.coleconomistes.cat/Paginas/Ficha.aspx?IdMenu=6e1423ca-ead3-4b81-82a8-454c8be68a4d&Idioma=ca-ES"
          target="_blank"
          rel="noreferrer"
        >
          <img
            alt="colaborador"
            src={fundacio}
            className="patrocinadors__item"
          />
        </a>
      </div>
      <SectionHeader
        title={"Suport institucional"}
        bottomMargin={true}
        marginTop={true}
      />
      <div className="patrocinadors__item-wrapper">
        <a
          href="https://web.gencat.cat/ca/inici/index.html"
          target="_blank"
          rel="noreferrer"
        >
          <img
            alt="patrocini"
            src={generalitat}
            className="patrocinadors__item"
          />
        </a>
      </div>
    </div>
  );
};

export default Patrocinadors;
